"use client";

import dynamic from "next/dynamic";
import BirthToolFormShell from "@/components/tool-shell/BirthToolFormShell";
import { useDeferredToolActivation } from "@/components/tool-shell/useDeferredToolActivation";

// Bundle-size discipline (2026-07-16 trim pass): MangalDoshaClient pulls the
// full BirthDetailsForm + PlaceAutocomplete + result/offer stack. Loading it
// via next/dynamic keeps that stack out of the en + hi route chunks and lets
// the bundler share ONE copy with the other deferred calculator islands.
// Height-reserving shell per rule 58; tool stays first-viewport per rule 43/61.
// The pre-activation shell and the chunk-loading shell carry the island's
// own form props, so every frame before the island mounts reads the same
// words as the island (see BirthToolFormShell.parity.test.tsx).
const SHELL_PROPS = {
  en: { language: "en", submitLabel: "Check Mangal Dosha", showTrustStrip: true },
  hi: { language: "hi", submitLabel: "मंगल दोष जाँचें", showTrustStrip: true },
} as const;

const ISLANDS = {
  en: dynamic(() => import("./MangalDoshaClient"), {
    ssr: false,
    loading: () => <BirthToolFormShell {...SHELL_PROPS.en} />,
  }),
  hi: dynamic(() => import("./MangalDoshaClient"), {
    ssr: false,
    loading: () => <BirthToolFormShell {...SHELL_PROPS.hi} />,
  }),
};

export default function DeferredMangalDoshaClient({
  defaultLanguage = "en",
}: {
  defaultLanguage?: "en" | "hi";
}) {
  const { ready, activate } = useDeferredToolActivation();
  const MangalDoshaClientPicked = ISLANDS[defaultLanguage];

  if (ready) return <MangalDoshaClientPicked defaultLanguage={defaultLanguage} />;

  return <BirthToolFormShell {...SHELL_PROPS[defaultLanguage]} onActivate={activate} />;
}
